import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import PayrollSystemWrapper from "@components/layouts/payrollSystemWrapper";

export default function PayrollSystemHome(): ReactElement {
    return (
        <PayrollSystemWrapper>
            <TermsAndConditions
                category="Payroll System"
                domain="PayrollSystem.com"
            />
        </PayrollSystemWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
